import { Observable, EMPTY as EMPTY_OBSERVABLE } from 'rxjs'
import { TOKENS_CAN_BE_COMPLETED } from '@aytm/app/stats/lib/render/draft-js/autocompletePlugin/lib/tokens'
import processSuggestionData from '@aytm/app/stats/lib/render/draft-js/autocompletePlugin/lib/process-suggestion-data'

export default function createVariableSuggestion(
  _,
  __,
  {
    dependencies: {
      aytmLogic: { refsList, traits, variables },
      parserResult
    }
  }
) {
  if (!variables || !parserResult || !refsList) {
    return EMPTY_OBSERVABLE
  }

  const extractTokens = variable => {
    if (refsList[variable]) {
      const prefix = refsList[variable].toUpperCase()

      return 'D' === prefix ? ['ISODATE'] : [prefix + 'REF', 'TRAIT']
    }

    return []
  }

  const transformToSuggestion =
    ({ canBeCompleted, parserResult, suggestionTokens }) =>
    variable => {
      const tokens = extractTokens(variable)
      const token = suggestionTokens.find(suggestionToken => tokens.find(token => suggestionToken === token))
      const label = variable.toLowerCase()

      const trait = traits.find(t => String(t.id).toLowerCase() === label)
      const description = trait != undefined && trait.id !== trait.title ? trait.title : null

      return token
        ? processSuggestionData('variable', { canBeCompleted, token, label, parserResult, description })
        : null
    }

  const createSuggestions = (suggestionTokens, canBeCompleted) =>
    variables
      .map(transformToSuggestion({ canBeCompleted, parserResult, suggestionTokens }))
      .filter(suggestion => suggestion)

  return new Observable(observer => {
    const {
      tokens: { expected, type },
      text: { nonParsed }
    } = parserResult

    const isLastTokenCompletable = TOKENS_CAN_BE_COMPLETED.includes(type.last)
    const hasNonParsedText = Boolean(nonParsed)
    const hasNonParsedTextTrimmed = Boolean(nonParsed.trim())
    const canBeCompleted = Boolean(hasNonParsedTextTrimmed || (!hasNonParsedText && isLastTokenCompletable))

    const suggestedLabels = []
    const suggestionTokens =
      !hasNonParsedText && isLastTokenCompletable ? expected.prelast || expected.last || [] : expected.last || []

    createSuggestions(suggestionTokens, canBeCompleted).forEach(suggestion => {
      suggestedLabels.push(suggestion.label)
      observer.next(suggestion)
    })

    if (canBeCompleted && suggestionTokens === expected.prelast) {
      createSuggestions(expected.last || [])
        .filter(suggestion => !suggestedLabels.includes(suggestion.label))
        .forEach(suggestion => observer.next(suggestion))
    }

    observer.complete()
  })
}
